'use strict';

class OriginatorAcceptInvite {
  constructor($location, $window, userService, originatorService, Notification) {
    this.$location = $location;
    this.$window = $window;
    this.userService = userService;
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.params = {
      id: this.$location.search().id,
      originatorId: this.$location.search().oid,
      dt: this.$location.search().dt,
      key: this.$location.search().key
    };

    this.options = {
      login: false,
      register: false
    };
    this.captchaResponse = null;

    this.newUser = {
      username: null,
      password: null,
      verifyPassword: null,
      name: null
    };

    this.existingUser = {
      username: null,
      password: null
    };

    this.validate();
  }

  fail() {
    this.options = {
      login: false,
      register: false
    };

    this.Notification.error('Linken er ikke gyldig');
  }

  validate() {
    if (this.params.originatorId) {
      this.originatorService.validateLink(this.params.originatorId, this.params)
        .then((resp) => {
          if (resp.status === 200) {
            this.options = {
              login: true,
              register: true
            };
          }
        })
        .catch(() => this.fail());
    } else {
      this.fail();
    }
  }

  accept(params) {
    angular.extend(this.params, {
      username: params.username,
      password: params.password
    });

    if (this.params.originatorId) {
      this.$window.sessionStorage.setItem('originatorId', this.params.originatorId);

      this.originatorService.acceptInvite(this.params.originatorId, this.params)
        .then(() => this.$location.path('/bytt-konto'))
        .catch((err) => {
          if (err.status === 409) {
            this.$location.path('/bytt-konto');
          } else {
            this.Notification.error(err.data.endUserMessage);
          }
        });
    } else {
      this.fail();
    }
  }

  compare(str1, str2) {
    return str1 !== str2;
  }

  register() {
    this.userService.registerUser(this.newUser, this.captchaResponse)
      .then(() => this.accept(this.newUser))
      .catch((err) => {
        this.Notification.error(err.data.endUserMessage);

        if (err.status !== 409) {
          this.options.register = false;
        }
      });
  }
}

OriginatorAcceptInvite.$inject = ['$location', '$window', 'userService', 'originatorService', 'Notification'];

const originatorAcceptInvite = {
  controller: OriginatorAcceptInvite,
  template: `
    <h2>Tilgang til SendRegning-konto</h2>

    <p>For &aring; f&aring; tilgang til SendRegning-kontoen du er invitert til &aring; dele, m&aring; du ha en bruker p&aring; SendRegning. Hvis du allerede bruker SendRegning, kan du koble tilgangen til din eksisterende bruker ved &aring; logge inn, hvis ikke m&aring; du registrere deg.</p>

    <div class="row">

      <div class="large-6 columns">
        <form ng-submit="$ctrl.accept($ctrl.existingUser)" name="loginForm" novalidate ng-cloak ng-if="$ctrl.options.login">
          <fieldset>
            <h3 class="subheader">Logg inn</h3>

            <div>
              <label for="username">E-postadresse</label>
              <input type="email" name="username" id="loginUsername" autocomplete="email" ng-model="$ctrl.existingUser.username" placeholder="ola@nordmann.no" autofocus required>
              <span class="error" ng-show="loginForm.username.$error.required && loginForm.username.$dirty">Vennligst oppgi en gyldig e-postadresse</span>
            </div>

            <div>
              <label for="password">Passord</label>
              <input type="password" name="password" id="loginPassword" ng-model="$ctrl.existingUser.password" autocomplete="current-password" placeholder="minst 8 tegn" required>
              <span class="error" ng-show="loginForm.password.$error.minlength && loginForm.password.$dirty">Vennligst oppgi et passord, minst 8 tegn</span>
            </div>

          </fieldset>

          <p><a href="#/glemt-passord">Glemt passord?</a></p>

          <button type="submit" class="button">Logg inn</button>
        </form>
      </div>

      <div class="large-6 columns">
        <form ng-submit="$ctrl.register()" name="registerForm" novalidate ng-cloak ng-if="$ctrl.options.register">
          <fieldset>
            <h3 class="subheader">Registrer deg</h3>

            <div>
              <label for="name">Navn</label>
              <input type="text" name="name" id="name" ng-model="$ctrl.newUser.name" placeholder="Ola Nordmann" autofocus required>
              <span class="error" ng-show="registerForm.name.$error.required && registerForm.name.$dirty">P&aring;krevd</span>
            </div>

            <div>
              <label for="regUsername">E-postadresse</label>
              <input type="email" name="username" id="username" autocomplete="email" ng-model="$ctrl.newUser.username" placeholder="ola@nordmann.no" required>
              <span class="error" ng-show="registerForm.username.$error.required && registerForm.username.$dirty">Vennligst oppgi en gyldig e-postadresse</span>
            </div>

            <div>
              <label for="regPass">Passord</label>
              <input type="password" name="password" id="password" autocomplete="new-password" ng-model="$ctrl.newUser.password" maxlength="36" placeholder="minst 8 tegn" required password-validator-register>
            </div>

            <div>
              <label for="regVerifyPass">Gjenta passord</label>
              <input type="password" name="verifyPassword" id="verifyPassword" autocomplete="off" ng-model="$ctrl.newUser.verifyPassword" maxlength="36" placeholder="minst 8 tegn" required>
              <span class="error" ng-show="$ctrl.compare($ctrl.newUser.password, $ctrl.newUser.verifyPassword)">Passordene stemmer ikker overens</span>
            </div>

          </fieldset>

          <p>
            <div vc-recaptcha ng-model="$ctrl.captchaResponse"></div>
          </p>

          <button type="submit" class="button" ng-disabled="registerForm.$invalid; $ctrl.compare($ctrl.newUser.password, $ctrl.newUser.verifyPassword)">Registrer</button>
        </form>
      </div>

    </div>
  `
};

angular
  .module('SendRegning')
  .component('originatorAcceptInvite', originatorAcceptInvite)
  .config(($routeProvider) => {
    $routeProvider
      .when('/bytt-konto/aksepter', {
        title: 'Aksepter invitasjon',
        template: '<originator-accept-invite />',
        noSidebar: true,
        noNotification: true,
        noNav: true,
        secure: false
      });
  });
